export default __webpack_public_path__ + "static/media/log-out.b9a37f93.svg";